/* @generated */

// src/assets/ui-icon/line/upsell.tsx
import * as React from "react";
var UpsellLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M18.814 10H14.5V2.695L5.185 14H9.5v7.31L18.814 10Zm-10.45 2.5L13 6.875V11.5h2.636L11 17.13V12.5H8.364Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  UpsellLine
};
